import React from 'react'
import SailorRooDatePicker from '@sailor/fe-infra-component/dist/es/SailorRooDatePicker'
import { getDateTimePattern, getI18nParams, isRtl } from '@/common/utils/i18n'
import { DatePickerProps, RangePickerProps } from '@roo/roo/DatePicker/interface'
import { MCalendar } from '@sailor/i18n-web'
import { getCurCityId } from '@/common/utils/i18nFuncs'
import dayjs from 'dayjs'

const PICKER_FORMATTER = 'YYYY-MM-DD HH:mm:ss'

function RegionDatePicker (props: DatePickerProps) {
  return (<SailorRooDatePicker
    value={props.value}
    onChange={props.onChange}
    showTime
    format={PICKER_FORMATTER}
    regionCode={getI18nParams().region}
    placement={isRtl ? 'bottomRight' : 'bottomLeft'}
    {...props}
  />)
}

export function RegionDateRangePicker (props: RangePickerProps) {
  return (<SailorRooDatePicker.RangePicker
    value={props.value}
    onChange={props.onChange}
    showTime
    format={PICKER_FORMATTER}
    regionCode={getI18nParams().region}
    {...props}
  />)
}

export function getStartOfDay () {
  return MCalendar.dayStartTime(getCurCityId(), dayjs().valueOf())
}


export default RegionDatePicker
